module.exports = __webpack_public_path__ + "static/img/kmR410A.47aeb98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/internationalBrand/kmR410A.jpg
// module id = 8AHd
// module chunks = 1